const infoStripe = document.getElementById("azm-info-stripe")

export function hideInfoStripe() {
    infoStripe?.setAttribute("hidden", "")
}

export function showInfoStripe() {
    infoStripe?.removeAttribute("hidden")
}
